import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  TopToolbar,
  FilterButton,
  ExportButton,
  useListContext, useNotify,
} from 'react-admin';
import { cms1500JobsFields } from '../cms1500Jobs.model';
import PatientLinkField from './fields/patientLinkField.component';
import HealthieCms1500LinkField from './fields/healthieCms1500LinkField.component';
import DefaultPlaceholderField from '../../material/defPlaceholderField.component';
import {DATE_TIME_OPTIONS} from "@/app/app.component";
import { Cms1500JobsFilters } from './utils/cms1500JobsFilters';
import { cms1500JobsExporter } from "./utils/cms1500JobsExport";
import {DEFAULT_LIST_PERPAGE} from "utils/constants";

const ListActions = () => {
  const { total } = useListContext();
  const notify = useNotify();

  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton
        disabled={total === 0}
        exporter={(jobs) => cms1500JobsExporter(jobs, notify)}
      />
    </TopToolbar>
  );
};

const Cms1500JobsList = () => (
  <List
    filters={Cms1500JobsFilters}
    exporter={cms1500JobsExporter}
    actions={<ListActions />}
    perPage={DEFAULT_LIST_PERPAGE}
    sort={{ field: cms1500JobsFields.createdAt, order: 'DESC' }}
    filterDefaultValues={{
      patient_id: '',
    }}
    displayedFilters={{
      patient_id: true,
    }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <DefaultPlaceholderField
        source={cms1500JobsFields.id}
        label="ID"
        wrapField={<TextField source={cms1500JobsFields.id} />}
      />
      <DefaultPlaceholderField
        source={cms1500JobsFields.formAnswerGroupId}
        label="Chart Note ID"
        wrapField={<TextField source={cms1500JobsFields.formAnswerGroupId} />}
      />
      <PatientLinkField source={cms1500JobsFields.patientId} label="Patient ID" addLabel />
      <DefaultPlaceholderField
        source={cms1500JobsFields.appointmentId}
        label="Appointment ID"
        wrapField={<TextField source={cms1500JobsFields.appointmentId} />}
      />
      <DefaultPlaceholderField
        source={cms1500JobsFields.status}
        label="Status"
        wrapField={<TextField source={cms1500JobsFields.status} />}
      />
      <HealthieCms1500LinkField source={cms1500JobsFields.healthieCms1500Id} label="Healthie CMS1500 ID" addLabel />
      <DefaultPlaceholderField
        source={cms1500JobsFields.attemptCount}
        label="Attempt Count"
        wrapField={<TextField source={cms1500JobsFields.attemptCount} />}
      />
      <DefaultPlaceholderField
        source={cms1500JobsFields.lastErrorMessage}
        label="Last Error Message"
        wrapField={<TextField source={cms1500JobsFields.lastErrorMessage} />}
      />
      <DefaultPlaceholderField
        source={cms1500JobsFields.lastAttemptedAt}
        options={DATE_TIME_OPTIONS}
        wrapField={<DateField/>}
        label="Last Attempted At"
      />
      <DefaultPlaceholderField
        source={cms1500JobsFields.createdAt}
        options={DATE_TIME_OPTIONS}
        wrapField={<DateField/>}
        label="Created At"
      />
    </Datagrid>
  </List>
);

export default Cms1500JobsList;
